<script>
import Layout from "@/views/layouts/main.vue";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";
import http from "@/services/http";
import appConfig from "@/app.config.json";

export default {
  name: "DetailTransportContract",
  page: {
    title: "収集運搬契約詳細",
    meta: [{ name: "description", content: appConfig.description }]
  },
  data() {
    return {
      transportContract: {
        "case": {
          "discharger": {},
          "discharger_site": {}
        },
        "waste_category_by_contract": [],
        "vendor_id_section1": {},
        "vendor_id_section2": {},
        "vendor_id_section3": {},
        "vendor_id_section4": {},
        "vendor_id_section5": {},
        "vendor_car_id1": {},
        "vendor_car_id2": {},
        "vendor_car_id3": {},
        "vendor_car_id4": {},
        "vendor_car_id5": {},
        "zz_jw_transport_method1": {},
        "zz_jw_transport_method2": {},
        "zz_jw_transport_method3": {},
        "zz_jw_transport_method4": {},
        "zz_jw_transport_method5": {},
        "vendor_site_id_section1": {},
        "vendor_site_id_section2": {},
        "vendor_site_id_section3": {},
        "vendor_site_id_section4": { },
        "vendor_site_id_section5": {}
      }
    };
  },
  components: {
    Layout,
    CommonTableComponent
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;

      const url = apiEndpoints.projects_sales_transport_contract_detail(this.$route.params.id, this.$route.params.contract_id);

      const sendApiProject = await http.get(url, {});
      const { status, data } = sendApiProject;
      if (status) {
        this.transportContract = data.result;
      }

      this.isLoading = false;
    },
    backToList() {
      let query = (localStorage.getItem('projects/sales/contract') == null)
        ? { activeTabIndex: this.$constant.pages.project.sales.contract.tabIndex }
        : JSON.parse(localStorage.getItem('projects/sales/contract'))
      this.$router.push({
        name: "projects.sales",
        params: { id: this.projectId },
        query: query
      });
    },
    displayPermit(key) {
      const result = [];
      if (!this.transportContract) return '';
      if (!this.transportContract[key]) return '';

      if (this.transportContract[key].vendor && this.transportContract[key].vendor.name_abbreviated) {
        result.push(this.transportContract[key].vendor.name_abbreviated);
      }

      if (this.transportContract[key].zz_municipality && this.transportContract[key].zz_municipality.municipality) {
        result.push(this.transportContract[key].zz_municipality.municipality);
      }

      if (this.transportContract[key].permit_number) {
        result.push(this.transportContract[key].permit_number);
      }

      return result.join(" ")
    },
    displayAddress(keyVendor, keyAddress1) {
      if (!this.transportContract) return '';
      if (!this.transportContract[keyVendor]) return '';
      if (this.transportContract[keyVendor][keyAddress1]) {
        return this.transportContract[keyVendor][keyAddress1]
      }

      return "";
    },
    displayLink(){
      return !(this.transportContract.ni_id == null);
    },
    toNI(){
      if(!this.transportContract.ni_id) return "";
      return this.$constant.ni_transport_contract_uri + this.transportContract.ni_id;
    }
  },
  computed: {
    projectId() {
      return this.$route.params.id;
    },
    contractId() {
      return this.$route.params.contract_id;
    }
  }
};
</script>
<template>
  <Layout>
    <b-container fluid>
      <div class="d-flex justify-content-end mb-2">
        <b-button variant="primary" size="lg" @click="backToList()">{{
            this.$lang.button.back
          }}</b-button>
      </div>
      <b-card :show="isLoading">
        <b-row v-if="displayLink()">
          <div class="content-block mb-3">
          <a target="_blank" :href="toNI()">
            NIコラボ上での契約情報・添付ファイルの確認はこちら
          </a>
          <i class="fas fa-clone"></i>
          </div>
        </b-row>
      
        <b-row>
          <div class="table-responsive">
            <table
              class="table table-hover table-borderless align-middle table-centered table-nowrap mb-0 table-striped"
            >
              <thead class="table-light">
              <tr>
                <th>CA管理番号</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ transportContract.transport_contract_cd }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-row>

        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">契約基本情報</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th>収集運搬契約名</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.transport_contract_name }}</p>
                  </td>
                </tr>
                <tr>
                  <th>商流</th>
                </tr>
                <tr>
                  <p v-if="transportContract.case">{{ transportContract.case.case_name }}</p>
                </tr>
                <tr>
                  <th>事業者</th>
                </tr>
                <tr>
                  <td>
                    <p v-if="transportContract.case && transportContract.case.discharger">{{ transportContract.case.discharger.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th>事業場</th>
                </tr>
                <tr>
                  <td>
                    <p v-if="transportContract.case && transportContract.case.discharger_site">{{ transportContract.case.discharger_site.name_abbreviated }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">収集運搬業者及び積卸先</div>
            <div class="title title-bg-blue mr-2">区間１</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th>作業日報対象１</th>
                  <th>収集運搬業者１</th>
                  <th>運搬方法１</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.is_daily_report_id_section_1 ? "作業日報対象" : ""}}</p>
                  </td>
                  <td>
                    <p v-if="transportContract.vendor_id_section1">{{ transportContract.vendor_id_section1.name_abbreviated }}</p>
                  </td>
                  <td>
                    <p v-if="transportContract.zz_jw_transport_method1">{{ transportContract.zz_jw_transport_method1.jw_transport_method }}</p>
                  </td>
                </tr>
                <tr>
                  <th>輸送距離１</th>
                  <th colspan="2">他社車両1</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.transport_distance_section_1 ? transportContract.transport_distance_section_1 : "" }}</p>
                  </td>
                  <td colspan="2">
                    <p v-if="transportContract.vendor_car_id1">{{ transportContract.vendor_car_id1.name }}</p>
                  </td>
                </tr>
                <tr>
                  <th>排出事業者自己運搬１</th>
                  <th colspan="2">積卸先１</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.is_transport_by_discharger_id_section_1 == 1 ? "排出事業者自己運搬" : "" }}</p>
                  </td>
                  <td colspan="2">
                    <p v-if="transportContract.vendor_site_id_section1">{{ transportContract.vendor_site_id_section1.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th>運搬の最終目的地１</th>
                  <th>都道府県</th>
                  <th>市区町村</th>
                </tr>
                <tr>
                  <td rowspan="3">
                    <p>{{ transportContract.is_final_destination_section_1 ? "運搬の最終目的地" : "" }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section1", "address_1") }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section1", "address_2") }}</p>
                  </td>
                </tr>
                <tr>
                  <th>町域</th>
                  <th>番地・建物名</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section1", "address_3") }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section1", "address_4") }}</p>
                  </td>
                </tr>
                <tr>
                  <th>運搬事業者許可番号１(普通産廃）</th>
                  <th colspan="2">運搬事業者許可番号１（特管産廃）</th>
                </tr>
                <tr>
                  <td>
                    <p>
                      {{ displayPermit('permit_discharger_waste1') }}
                    </p>
                  </td>
                  <td colspan="2">
                    <p>
                      {{ displayPermit('permit_discharger_special_waste1') }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>積卸先許可情報１（普通産廃）</th>
                  <th colspan="2">積卸先許可情報１（特管産廃）</th>
                </tr>
                <tr>
                  <td>
                    <p>
                      {{ displayPermit('permit_distination_waste1') }}
                    </p>
                  </td>
                  <td colspan="2">
                    <p>
                      {{ displayPermit('permit_distination_special_waste1') }}
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="title title-bg-blue mr-2">区間２</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th>作業日報対象２</th>
                  <th>収集運搬業者２</th>
                  <th>運搬方法２</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.is_daily_report_id_section_2 ? "作業日報対象" : ""}}</p>
                  </td>
                  <td>
                    <p v-if="transportContract.vendor_id_section2">{{ transportContract.vendor_id_section2.name_abbreviated }}</p>
                  </td>
                  <td>
                    <p v-if="transportContract.zz_jw_transport_method2">{{ transportContract.zz_jw_transport_method2.jw_transport_method }}</p>
                  </td>
                </tr>
                <tr>
                  <th>輸送距離２</th>
                  <th colspan="2">他社車両２</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.transport_distance_section_2 ? transportContract.transport_distance_section_2 : "" }}</p>
                  </td>
                  <td colspan="2">
                    <p v-if="transportContract.vendor_car_id2">{{ transportContract.vendor_car_id2.name }}</p>
                  </td>
                </tr>
                <tr>
                  <th>排出事業者自己運搬２</th>
                  <th colspan="2">積卸先２</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.is_transport_by_discharger_id_section_2 == 1 ? "排出事業者自己運搬" : "" }}</p>
                  </td>
                  <td colspan="2">
                    <p v-if="transportContract.vendor_site_id_section2">{{ transportContract.vendor_site_id_section2.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th>運搬の最終目的地２</th>
                  <th>都道府県</th>
                  <th>市区町村</th>
                </tr>
                <tr>
                  <td rowspan="3">
                    <p>{{ transportContract.is_final_destination_section_2 ? "運搬の最終目的地" : "" }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section2", "address_1") }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section2", "address_2") }}</p>
                  </td>
                </tr>
                <tr>
                  <th>町域</th>
                  <th>番地・建物名</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section2", "address_3") }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section2", "address_4") }}</p>
                  </td>
                </tr>
                <tr>
                  <th>運搬事業者許可番号２(普通産廃）</th>
                  <th colspan="2">運搬事業者許可番号２（特管産廃）</th>
                </tr>
                <tr>
                  <td>
                    <p>
                      {{ displayPermit('permit_discharger_waste2') }}
                    </p>
                  </td>
                  <td colspan="2">
                    <p>
                      {{ displayPermit('permit_discharger_special_waste2') }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>積卸先許可情報２（普通産廃）</th>
                  <th colspan="2">積卸先許可情報２（特管産廃）</th>
                </tr>
                <tr>
                  <td>
                    <p>
                      {{ displayPermit('permit_distination_waste2') }}
                    </p>
                  </td>
                  <td colspan="2">
                    <p>
                      {{ displayPermit('permit_distination_special_waste2') }}
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="title title-bg-blue mr-2">区間３</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th>作業日報対象３</th>
                  <th>収集運搬業者３</th>
                  <th>運搬方法３</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.is_daily_report_id_section_3 ? "作業日報対象" : ""}}</p>
                  </td>
                  <td>
                    <p v-if="transportContract.vendor_id_section3">{{ transportContract.vendor_id_section3.name_abbreviated }}</p>
                  </td>
                  <td>
                    <p v-if="transportContract.zz_jw_transport_method3">{{ transportContract.zz_jw_transport_method3.jw_transport_method }}</p>
                  </td>
                </tr>
                <tr>
                  <th>輸送距離３</th>
                  <th colspan="2">他社車両３</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.transport_distance_section_3 ? transportContract.transport_distance_section_3 : "" }}</p>
                  </td>
                  <td colspan="2">
                    <p v-if="transportContract.vendor_car_id3">{{ transportContract.vendor_car_id3.name }}</p>
                  </td>
                </tr>
                <tr>
                  <th>排出事業者自己運搬３</th>
                  <th colspan="2">積卸先３</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.is_transport_by_discharger_id_section_3 == 1 ? "排出事業者自己運搬" : "" }}</p>
                  </td>
                  <td colspan="2">
                    <p v-if="transportContract.vendor_site_id_section3">{{ transportContract.vendor_site_id_section3.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th>運搬の最終目的地３</th>
                  <th>都道府県</th>
                  <th>市区町村</th>
                </tr>
                <tr>
                  <td rowspan="3">
                    <p>{{ transportContract.is_final_destination_section_3 ? "運搬の最終目的地" : "" }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section3", "address_1") }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section3", "address_2") }}</p>
                  </td>
                </tr>
                <tr>
                  <th>町域</th>
                  <th>番地・建物名</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section3", "address_3") }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section3", "address_4") }}</p>
                  </td>
                </tr>
                <tr>
                  <th>運搬事業者許可番号３(普通産廃）</th>
                  <th colspan="2">運搬事業者許可番号３（特管産廃）</th>
                </tr>
                <tr>
                  <td>
                    <p>
                      {{ displayPermit('permit_discharger_waste3') }}
                    </p>
                  </td>
                  <td colspan="2">
                    <p>
                      {{ displayPermit('permit_discharger_special_waste3') }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>積卸先許可情報３（普通産廃）</th>
                  <th colspan="2">積卸先許可情報３（特管産廃）</th>
                </tr>
                <tr>
                  <td>
                    <p>
                      {{ displayPermit('permit_distination_waste3') }}
                    </p>
                  </td>
                  <td colspan="2">
                    <p>
                      {{ displayPermit('permit_distination_special_waste3') }}
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="title title-bg-blue mr-2">区間４</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th>作業日報対象４</th>
                  <th>収集運搬業者４</th>
                  <th>運搬方法４</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.is_daily_report_id_section_4 ? "作業日報対象" : ""}}</p>
                  </td>
                  <td>
                    <p v-if="transportContract.vendor_id_section4">{{ transportContract.vendor_id_section4.name_abbreviated }}</p>
                  </td>
                  <td>
                    <p v-if="transportContract.zz_jw_transport_method4">{{ transportContract.zz_jw_transport_method4.jw_transport_method }}</p>
                  </td>
                </tr>
                <tr>
                  <th>輸送距離４</th>
                  <th colspan="2">他社車両４</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.transport_distance_section_4 ? transportContract.transport_distance_section_4 : "" }}</p>
                  </td>
                  <td colspan="2">
                    <p v-if="transportContract.vendor_car_id4">{{ transportContract.vendor_car_id4.name }}</p>
                  </td>
                </tr>
                <tr>
                  <th>排出事業者自己運搬４</th>
                  <th colspan="2">積卸先４</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.is_transport_by_discharger_id_section_4 == 1 ? "排出事業者自己運搬" : "" }}</p>
                  </td>
                  <td colspan="2">
                    <p v-if="transportContract.vendor_site_id_section4">{{ transportContract.vendor_site_id_section4.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th>運搬の最終目的地４</th>
                  <th>都道府県</th>
                  <th>市区町村</th>
                </tr>
                <tr>
                  <td rowspan="3">
                    <p>{{ transportContract.is_final_destination_section_4 ? "運搬の最終目的地" : "" }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section4", "address_1") }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section4", "address_2") }}</p>
                  </td>
                </tr>
                <tr>
                  <th>町域</th>
                  <th>番地・建物名</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section4", "address_3") }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section4", "address_4") }}</p>
                  </td>
                </tr>
                <tr>
                  <th>運搬事業者許可番号４(普通産廃）</th>
                  <th colspan="2">運搬事業者許可番号４（特管産廃）</th>
                </tr>
                <tr>
                  <td>
                    <p>
                      {{ displayPermit('permit_discharger_waste4') }}
                    </p>
                  </td>
                  <td colspan="2">
                    <p>
                      {{ displayPermit('permit_discharger_special_waste4') }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>積卸先許可情報４（普通産廃）</th>
                  <th colspan="2">積卸先許可情報４（特管産廃）</th>
                </tr>
                <tr>
                  <td>
                    <p>
                      {{ displayPermit('permit_distination_waste4') }}
                    </p>
                  </td>
                  <td colspan="2">
                    <p>
                      {{ displayPermit('permit_distination_special_waste4') }}
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="title title-bg-blue mr-2">区間５</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th>作業日報対象５</th>
                  <th>収集運搬業者５</th>
                  <th>運搬方法５</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.is_daily_report_id_section_5 ? "作業日報対象" : ""}}</p>
                  </td>
                  <td>
                    <p v-if="transportContract.vendor_id_section5">{{ transportContract.vendor_id_section5.name_abbreviated }}</p>
                  </td>
                  <td>
                    <p v-if="transportContract.zz_jw_transport_method5">{{ transportContract.zz_jw_transport_method5.jw_transport_method }}</p>
                  </td>
                </tr>
                <tr>
                  <th>輸送距離５</th>
                  <th colspan="2">他社車両５</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.transport_distance_section_5 ? transportContract.transport_distance_section_5 : "" }}</p>
                  </td>
                  <td colspan="2">
                    <p v-if="transportContract.vendor_car_id5">{{ transportContract.vendor_car_id5.name }}</p>
                  </td>
                </tr>
                <tr>
                  <th>排出事業者自己運搬５</th>
                  <th colspan="2">積卸先５</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.is_transport_by_discharger_id_section_5 == 1 ? "排出事業者自己運搬" : "" }}</p>
                  </td>
                  <td colspan="2">
                    <p v-if="transportContract.vendor_site_id_section5">{{ transportContract.vendor_site_id_section5.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th>運搬の最終目的地５</th>
                  <th>都道府県</th>
                  <th>市区町村</th>
                </tr>
                <tr>
                  <td rowspan="3">
                    <p>{{ transportContract.is_final_destination_section_5 ? "運搬の最終目的地" : "" }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section5", "address_1") }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section5", "address_2") }}</p>
                  </td>
                </tr>
                <tr>
                  <th>町域</th>
                  <th>番地・建物名</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section5", "address_3") }}</p>
                  </td>
                  <td>
                    <p>{{ displayAddress("vendor_site_id_section5", "address_4") }}</p>
                  </td>
                </tr>
                <tr>
                  <th>運搬事業者許可番号５(普通産廃）</th>
                  <th colspan="2">運搬事業者許可番号５（特管産廃）</th>
                </tr>
                <tr>
                  <td>
                    <p>
                      {{ displayPermit('permit_discharger_waste5') }}
                    </p>
                  </td>
                  <td colspan="2">
                    <p>
                      {{ displayPermit('permit_discharger_special_waste5') }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>積卸先許可情報５（普通産廃）</th>
                  <th colspan="2">積卸先許可情報５（特管産廃）</th>
                </tr>
                <tr>
                  <td>
                    <p>
                      {{ displayPermit('permit_distination_waste5') }}
                    </p>
                  </td>
                  <td colspan="2">
                    <p>
                      {{ displayPermit('permit_distination_special_waste5') }}
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">その他情報</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th>委託契約有効期限</th>
                  <th>自動更新</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ transportContract.expiration_date }}</p>
                  </td>
                  <td>
                    <p>{{ transportContract.is_term_continuation == 1 ? "あり" : "" }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">委託する廃棄物の種類</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th>廃棄物種類</th>
                  <th>事前協議</th>
                  <th>事前協議有効期間</th>
                </tr>
                <tr v-for="wasteCategoryByContract in transportContract.waste_category_by_contract" v-if="transportContract.waste_category_by_contract">
                  <td>
                    <p v-if="wasteCategoryByContract.waste_category.name_abbreviated">{{ wasteCategoryByContract.waste_category.name_abbreviated }}</p>
                  </td>
                  <td>
                    <p>{{ wasteCategoryByContract.is_prior_consultation == 1 ? "あり" : "なし" }}</p>
                  </td>
                  <td>
                    <p>{{ wasteCategoryByContract.prior_consultation_expiration_date }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
      </b-card>
    </b-container>
  </Layout>
</template>
<style scoped lang="scss">
.content-block {
  .title {
    padding: 2px;
    color: #ffffff;
  }
  .title-bg-green {
    background-color: #2cb57e;
  }
  .title-bg-blue {
    background-color: #47bce8;
  }
  .w-50 {
    width: 50%;
  }
  .mr-2 {
    margin-top: 2px;
  }
  td[rowspan] {
    vertical-align: top;
    text-align: left;
  }
  table {
    table-layout: fixed;
    th, td {
      word-wrap: break-word;
      white-space: normal!important;
    }
  }
}
</style>
